import { render, staticRenderFns } from "./alermDes.vue?vue&type=template&id=1cdba714&scoped=true&"
import script from "./alermDes.vue?vue&type=script&lang=js&"
export * from "./alermDes.vue?vue&type=script&lang=js&"
import style0 from "./alermDes.vue?vue&type=style&index=0&id=1cdba714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdba714",
  null
  
)

component.options.__file = "alermDes.vue"
export default component.exports